import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
//icon
import { BiArrowBack } from 'react-icons/bi';

const FeedbackPage = ({
  title,
  message,
  maxHeight = false
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation(['backoffice']);

  return (
    <div
      className={`d-flex flex-column justify-content-between align-items-mt-5 p-5 w-100 alert alert-info ${maxHeight && 'h-100'
        }`}
      role="alert"
    >
      <span>
        <h4 className="alert-heading">{title || t('soon')}</h4>
        <p>{message || t('constructionSection')}</p>
      </span>
      <span>
        <hr className="w-100" />
        <strong role="button" onClick={() => navigate(-1)} className="mb-0">
          <BiArrowBack /> {t('back')}
        </strong>
      </span>
    </div>
  );
};

FeedbackPage.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string,
  maxHeight: PropTypes.bool,
};

export default FeedbackPage;
